export const Headers = Object.freeze({
	ORGANIZACION_ID: "X-MILEGAJO-ORGANIZACION-ID",
	EMPRESA_ID: "X-MILEGAJO-EMPRESA-ID",
	TIPO_USUARIO: "X-MILEGAJO-TIPO-USUARIO",
	NUMERO_DOCUMENTO_IDENTIDAD: "X-MILEGAJO-NUMERO-DOCUMENTO-IDENTIDAD",
});
